"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = exports.Notification = void 0;
const styled_1 = __importDefault(require("../../styles/styled"));
const flex_1 = require("../layout/flex");
exports.Notification = (0, styled_1.default)(flex_1.Flex)(({ theme }) => ({
    position: 'absolute',
    top: '-5px',
    zIndex: 1,
    left: 10,
    height: theme.space[4],
    lineHeight: '10px',
    background: theme.colors.red50,
    color: theme.text.color.light,
    fontSize: theme.text.size.small,
    fontFamily: theme.text.bodyFontFamily,
}));
exports.Container = styled_1.default.div({
    position: 'relative',
    display: 'flex',
    alignContent: 'center',
});
//# sourceMappingURL=notification_wrapper.styles.js.map